import React, {
  useMemo,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import Select, { components, StylesConfig } from "react-select";
import { ToastContainer, toast } from "react-toastify";
import { logout } from "../../utils";
import * as Icon from "react-bootstrap-icons";
import { AgGridReact } from "ag-grid-react";
import "./vendorDetails.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css";
import { getFromLS, setToLS } from "../../utils/storage";
import { ThreeCircles } from "react-loader-spinner";
import { set } from "lodash";
const VendorDetails = (vendor_details_props) => {

  console.log("VENDOR DETAILS PROPS: ", vendor_details_props)
  const [selectedVendorDetails, setSelectedVendorDetails] = useState([]);
  const [vendorsWrtFirm, setVendorsWrtFirm] = useState([{
    "FirmVendorId": "",
    "FirmId": "",
    "VendorCode": "",
    "VendorName": "",
    "Active": ""
  }]);
  const [selectedFirm, setSelectedFirm] = useState();
  const [selectedVendorId, setSelectedVendorId] = useState();
  const [isSelectOptionsLoading, setIsSelectOptionsLoading] = useState(true)
  const [dataSource, setDataSource] = useState(null);
  const [editedRows, setEditedRows] = useState([]);
  const [showSpinner, setShowSpinner] = useState(false);

  // Setting page url for helper function
  useEffect(() => {
    setToLS("url",  ["myflows"])
  }, [])


  const vendorDetailsGridRef = useRef();
  const containerStyle = useMemo(() => ({ width: "100%", height: "auto" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%", padding: "0px 10px" }), []);
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      resizable: true,
      animateRows: true,
    }),
    []
  );
  const onFirstDataRendered = useCallback((params) => {
    vendorDetailsGridRef.current.api.sizeColumnsToFit();
  }, []);

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };

  // Get all Vendor Details
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URI}/workflow/firm_vendors/credentials/`, requestOptions)
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((data) => {
        setVendorsWrtFirm(data["data"]);
      });
  }, []);
  const [selectOptions, setSelectOptions] = useState([])
  const [defaultSelectedOption, setDefaultSelectedOption] = useState({})
  const { Option, Control } = components;
  const IconOption = props => {
    // console.log("ICON OPTION PROPS: ", props)
    return(
    <Option {...props}>
      <img
        src={props.data.logo}
        style={{ width: 20, borderRadius: 100, marginRight: 10 }}
        alt={props.label}
      />
      {props.data.label}
    </Option>
    )
    };
  const IconControl = ({ children, ...props }) => { 
    // console.log("ICON CONTROL PROPS: ", children)
    return (
      <components.Control {...props}>
        <img
          src={props.selectProps.value.logo}
          style={{ width: 20, borderRadius: 100, marginLeft:5, marginRight: -1 }}
         alt={props.label}
      />
        {children}
      </components.Control>
    );
  };

useEffect(() => {
  console.log("VENDORS WRT FIRM: ", vendorsWrtFirm)
  if(Object.keys(vendor_details_props.credentialoption).length === 0){
    if (vendorsWrtFirm[0] != undefined) {
      const defaultOption = {
        value: vendorsWrtFirm[0].VendorCode,
        label: vendorsWrtFirm[0].VendorName,
        id: vendorsWrtFirm[0].VendorId,
        logo: vendorsWrtFirm[0].VendorLogoLink
      }
      fetchVendorDetails(defaultOption.id)
      const select_options = vendorsWrtFirm.map((elem) => {
        return {
          value: elem.VendorCode,
          label: elem.VendorName,
          id: elem.VendorId,
          logo: elem.VendorLogoLink
        };
      })
      setDefaultSelectedOption(select_options[0])
      console.log("SELECT OPTIONS: ", select_options)
      setSelectOptions(select_options)
      setSelectedFirm(defaultOption)
      setSelectedVendorId(select_options[0].id)
      console.log("DEFAULT SELECTED VENDOR ID: ", selectedVendorId)
    }
}else{
  if (vendorsWrtFirm[0] != undefined) {
    const select_options = []
    for(let vendor in vendorsWrtFirm){
      if(vendorsWrtFirm[vendor].VendorId==vendor_details_props.credentialoption.sourcevendorid){
        const defaultOption = {
          value: vendorsWrtFirm[vendor].VendorCode,
          label: vendorsWrtFirm[vendor].VendorName,
          id: vendorsWrtFirm[vendor].VendorId,
          logo: vendorsWrtFirm[vendor].VendorLogoLink
        }
        select_options.push(defaultOption)
        // setSelectedVendorId(defaultOption.id)
        // setSelectedFirm(defaultOption)
        // fetchVendorDetails(defaultOption.id)

      }else if(vendorsWrtFirm[vendor].VendorId==vendor_details_props.credentialoption.targetvendorid){
        const otheroption = {
          value: vendorsWrtFirm[vendor].VendorCode,
          label: vendorsWrtFirm[vendor].VendorName,
          id: vendorsWrtFirm[vendor].VendorId,
          logo: vendorsWrtFirm[vendor].VendorLogoLink
        }
        select_options.push(otheroption)
        setSelectedVendorId(otheroption.id)
        setSelectedFirm(otheroption)
        fetchVendorDetails(otheroption.id)
      }
    }
    console.log("SELECT OPTIONS: ", select_options)
    setDefaultSelectedOption(select_options[0])
    setSelectOptions(select_options)
  }
}
}, [vendorsWrtFirm])

const simpleComp = (p) => {
  console.log("SIMPLE COMP PROPS: ", p)
  if (p.data.FieldName == "Password" || p.data.FieldName == "ClientSecret" || p.data.FieldName == "RefreshToken" 
    || p.data.FieldName == "IntegratorKey" || p.data.FieldName == "AccessToken" || p.data.FieldName == "APIKey") {
    // console.log(p.value)
    // console.log(p.value.length)
    return (
      <>{"*".repeat(p.value.length)}</>
    );
  }
  else {
    return (
      <>{p.value}</>
    );
  }
};

const [columnDefs, setColumnDefs] = useState([
  { field: "FirmVendorId", hide: true, sizeColumnsToFit: true },
  { field: "FirmVendorDetailId", hide: true, sizeColumnsToFit: true },
  { field: "FieldName", suppressSizeToFit: true, cellClassRules: 'no-border-cell', cellStyle: { "fontWeight": '600' } },
  { field: "FieldValue", cellRenderer: simpleComp, editable: true, sizeColumnsToFit: true },
  { field: "FieldDescription",  sizeColumnsToFit: true, cellStyle: { "font-style": 'italic' } },
]);
const sortable = true;
const filter = true;
const resizable = true;

const onCellValueChanged = (event) => {
  setEditedRows([...editedRows, event.rowIndex]);
  console.log("ITEM CHANGED : ", [...editedRows, event.rowIndex]);
};

const onCellEditingStopped = (event) => {
  console.log("Event AFTER editing", event, [...editedRows, event.rowIndex]);
  setEditedRows([...editedRows, event.rowIndex]);
};

const transporter = (pill) => {
  vendor_details_props.transporter(pill);
};

const fetchVendorDetails = (id) => {
  // console.log("CALLED: ", id)
  if (id) {
    fetch(
      `${process.env.REACT_APP_BASE_URI}/workflow/firm_vendor_details/${id}`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((data) => {
        return data && data["data"];
      })
      .then((data) => {
        setSelectedVendorDetails(data);

        let mappedData =
          data &&
          data.map((el) => {
            return {
              FieldName: el.FieldName,
              FirmVendorId: el.FirmVendorId,
              FieldValue: el.FieldValue,
              FirmVendorDetailId: el.FirmVendorDetailId,
              Active: el.Active == "Y" ? "True" : "False",
              FieldDescription: el.FieldDescription
            };
          });
        setDataSource(mappedData);
      });
  }
}

const handleButtonClick = (event) => {
  if (event != null) {
    const { value, id } = event;
    setSelectedFirm(event);
    setDefaultSelectedOption(event)
    setEditedRows([]);
    fetchVendorDetails(id)
    setSelectedVendorId(event.id)
    // console.log("SAVE BUTTON CLICK: ", event)
  }
};

const getAllRows = () => {
  setShowSpinner(true);
  let rowData = [];

  editedRows &&
    vendorDetailsGridRef &&
    vendorDetailsGridRef.current &&
    vendorDetailsGridRef.current.api.forEachNode((node) => {
      if (editedRows.includes(node.rowIndex)) {
        rowData.push(node.data);
      }
    });
  
  console.log("EDITED ROWS: ", editedRows)
  console.log("ROW DATA: ", rowData)

  const mappedRowData =
    rowData &&
    rowData.map((el) => {
      return {
        FirmVendorDetailId: el.FirmVendorDetailId!=undefined?el.FirmVendorDetailId:null,
        FieldName: el.FieldName,
        FieldValue: el.FieldValue,
        Active: el.Active == "True" ? "Y" : "N",
      };
    });

    for(let row in mappedRowData){
      Object.assign(mappedRowData[row], {FirmVendorId: selectedVendorId})
    }
    console.log("MAPPED ROW DATA: ", mappedRowData) ;
    if(rowData.length == 0){
      setShowSpinner(false);
      toast.info("No changes were made to save.", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "toastify-color-info",
      });
      return rowData;
    }
  const postOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    body: JSON.stringify(mappedRowData),
  };

    fetch(`${process.env.REACT_APP_BASE_URI}/workflow/firm_vendor_details/`, postOptions)
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((data) => {
        const success = data["success"];
        const message = data["message"];
        setShowSpinner(false);
        if (success){
          toast.success("vendor Details Saved successfully!", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            className: "toastify-color-success",
          });
        }
        else{
            toast.error(message, {
              position: "bottom-right",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              className: "toastify-color-error",
            });
        }
        
      })
      .catch((err) => {
        console.log("Err: ", err)
        setShowSpinner(false);
      });
      
  return rowData;
};

const onGridReady = useCallback(() => {
  dataSource && setDataSource(dataSource);
}, []);

return (
  <>
    <Row className="no-gutter">
      {/* <Col xs={2} >
        <div className="directions">
          <Icon.CaretLeftFill onClick={() => transporter("recommendation")} />
        </div>
      </Col> */}
        <h2 className="display-6">Please fill in the vendor details:</h2>
        {/* <h5 style={{ margin: "10px 0px 30px 10px" }}>Please fill in these details for us to set up workflow connections between the selected vendor apps.</h5> */}
        <hr />
        <Row className="no-gutter">
          <Col xs={3} className="mb-3">
            {vendorsWrtFirm && (
              <Select
                options={selectOptions}
                value={defaultSelectedOption}
                onChange={handleButtonClick}
                components={{ Control: IconControl, Option: IconOption }}
                placeholder={"Please select a vendor to fill in the details"}
                aria-label="Default"
                autosize={true}
                menuPosition="fixed"
                className=""
                // isLoading={isSelectOptionsLoading}
              />
            )}
          </Col>
          {selectedFirm && dataSource && editedRows && (
            <Col xs={1} style={{ padding: 0 }}>
              <Button
                style={{ float: "right" }}
                className="save-btn"
                onClick={() => getAllRows()}
              >
                Save
              </Button>
            </Col>
          )}
           <Col xs={1} style={{ padding: 0 }}> 
           { showSpinner &&    <ThreeCircles
                                                height="30"
                                                width="30"
                                                color="#4fa94d"
                                                wrapperStyle={{}}
                                                wrapperClass=""
                                                visible={true}
                                                ariaLabel="three-circles-rotating"
                                                outerCircleColor="var(--theme1_tertiary)"
                                                innerCircleColor="var(--theme1_secondary)"
                                                middleCircleColor="var(--theme1_primary)"
                                            /> 
           }
          </Col> 
          <Col xs={6}> <p className="vendor-assurance-row">*Your credentials will be stored  <b>securely</b><Icon.CheckAll></Icon.CheckAll> and <b>encrypted</b> <Icon.ShieldLock></Icon.ShieldLock>.</p></Col>
        </Row>

        {/* <Row className="selected-firm no-gutter">
          <Col xs={1} className="text-center selected-logo">
            <div className="selected-logo-wrapper">
              {
                selectedFirm && <Image src={require("../vendorimages/" + (selectedFirm.value ? selectedFirm.value : "undefined") + ".png")} className="selected-logo-image" rounded />
              }

            </div>
          </Col>
          <Col xs={5} className="selected-title">
            <h6>{selectedFirm ? selectedFirm.label : ""}</h6>
          </Col>
          <Col xs={6} className="mt-3"></Col>
        </Row> */}
        
        {selectedFirm && dataSource && (
          <div style={containerStyle} className="vendor-details-grid">
            <div className="ag-theme-balham" style={gridStyle}>
              <AgGridReact
                ref={vendorDetailsGridRef}
                rowData={dataSource}
                columnDefs={columnDefs}
                alwaysShowHorizontalScroll={false}
                alwaysShowVerticalScroll={false}
                sortable={sortable}
                filter={filter}
                resizable={resizable}
                onFirstDataRendered={onFirstDataRendered}
                onCellValueChanged={(item) => onCellValueChanged(item)}
                onCellEditingStopped={(event) => onCellEditingStopped(event)}
                rowHeight={60}
                suppressRowHoverHighlight={true}
                singleClickEdit={true}
                domLayout='autoHeight'
                stopEditingWhenCellsLoseFocus={true}
                enableCellChangeFlash={true}
                defaultColDef={defaultColDef}
              />
            </div>
          </div>
        )}
      {/* <Col xs={2} >
        <div className="directions">
          <Icon.CaretRightFill onClick={() => transporter("mapping")} />
        </div>
      </Col> */}
    </Row>
  </>
);
};

export default VendorDetails;
